import Hybrids from "../../Components/Hybrids";

export const HybridsComponent = () => {
    return (
      <>
        <Hybrids title={"Hybrids"} />
      </>
    );
  };